var scope_0 = require('/home/runner/work/justine-severino/justine-severino/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2dff74db8db560737c8cf51093ff5122.js').default;
var scope_1 = require('/home/runner/work/justine-severino/justine-severino/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3a14d4333a705f8e85480e0b24496cbf.js').default;
var scope_2 = require('/home/runner/work/justine-severino/justine-severino/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e818a062eeb3c6aba5798eebf0c33953.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    